import type { ReactNode } from 'react';
import {
  CheckCircleFilled,
  CloseCircleFilled,
  ExclamationCircleFilled,
  InfoCircleFilled,
  LoadingOutlined,
} from '@/components/icon/tabler';

export type SemanticStatus =
  | 'success'
  | 'error'
  | 'warning'
  | 'info'
  | 'loading';

const STATUS_ICON: Record<SemanticStatus, ReactNode> = {
  success: <CheckCircleFilled />,
  error: <CloseCircleFilled />,
  warning: <ExclamationCircleFilled />,
  info: <InfoCircleFilled />,
  loading: <LoadingOutlined spin />,
};

export function SemanticStatusIcon({ type }: { type: SemanticStatus }) {
  return (
    <span
      className={`qm-status-icon qm-status-icon-${type}`}
      data-toast-icon={type}
      data-tour={`toast-icon-${type}`}
    >
      {STATUS_ICON[type]}
    </span>
  );
}
